import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-6 md:px-10 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <Link to="/" className="font-heading text-lg font-bold text-foreground-900 cursor-pointer">
              Basetao Spreadsheet
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
              Your trusted resource hub for Basetao spreadsheet guides, product research, shipping information, and expert reviews.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <a href="#spreadsheet" className="text-sm text-foreground-600 cursor-pointer hover:text-primary-500 transition-colors">Spreadsheet Resources</a>
              <a href="#categories" className="text-sm text-foreground-600 cursor-pointer hover:text-primary-500 transition-colors">Product Categories</a>
              <Link to="/basetao-spreadsheet-guide" className="text-sm text-foreground-600 cursor-pointer hover:text-primary-500 transition-colors">Complete Guide</Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 cursor-pointer hover:text-primary-500 transition-colors">Main Website</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">Disclaimer</h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              This website provides educational information and resources. Users should verify product details before making purchasing decisions. We are an independent resource hub and not affiliated with Basetao.
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Basetao Spreadsheet Resource Hub. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors">
              Visit Main Site
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}